import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

descriptionStyles.wrapper = {
    css: css`
        margin-bottom: 15px;
        opacity: 1;
        color: ${COLORS.black};
        font-family: ${TYPOGRAPHY.fontFamily.montserrat};
        font-size: ${TYPOGRAPHY.size.smaller};
        font-weight: ${TYPOGRAPHY.weight.baseBold};
        font-style: normal;
        letter-spacing: 0px;
        div, p, span, li, ul, ol, section, main, body
            font-size: ${TYPOGRAPHY.size.smaller};
            font-family: ${TYPOGRAPHY.fontFamily.montserrat};
            font-weight: ${TYPOGRAPHY.weight.baseBold};
    `,
};
